import { createAction, props } from '@ngrx/store';

import { CustomizationPage } from '@common/modules/core/services/interfaces';

export const initPage = createAction('[CustomizationView] Init Page', props<{ page: CustomizationPage }>());
